// Semantic-version tuple compare (DEV_TECH_DESIGN-0030 §5.5). A plain string
// compare would order "0.9.0" after "0.10.0"; comparing numeric tuples does
// not. Returns -1, 0 or 1 for a < b, a == b, a > b.
export function compareVersions(a, b) {
    const parse = v => String(v).split('.').map(part => parseInt(part, 10) || 0);
    const pa = parse(a);
    const pb = parse(b);
    const length = Math.max(pa.length, pb.length);
    for (let i = 0; i < length; i++) {
        const da = pa[i] || 0;
        const db = pb[i] || 0;
        if (da !== db) return da < db ? -1 : 1;
    }
    return 0;
}
